import { getNumRows } from '../../../Utils/Common.js';
import * as TYPES from '../../types.js';
import {
    ToastSuccess,
    ToastDanger,
    ToastWarning,
} from '../../../Services/_toast.service';
import { SwalWarning, SwalWarningHtml } from '../../../Services/_swal.service';
import $ from 'jquery';
import { blockRoute, setMUIPage } from '../helper/helper.actions';
import { ReportsService } from './_service.reports.js';

// handle inputs
export const handleInputChange = (e) => async (dispatch) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({
        type: TYPES.REPORT_INPUT_CHANGE,
        payload: { key: e.target.name, value: e.target.value },
    });
};

// handle edit inputs
export const handleSearchInput = (e) => async (dispatch) => {
    dispatch({ type: TYPES.REPORT_SEARCH, payload: e.target.value });
};

// loading
export const setLoading = (status) => async (dispatch) =>
    dispatch({ type: TYPES.SET_LOADING, payload: status });

// clear data
export const clearReport = () => async (dispatch) =>
    dispatch({ type: TYPES.CLEAR_REPORT });

// set page
export const setPage =
    (page, id, status = true) =>
    async (dispatch, getState) => {
        let { edit_url } = getState().report;

        switch (page) {
            case 'main_report_page':
                dispatch({ type: TYPES.SET_PAGE, payload: { page, status } });
                dispatch(clearReport());
                break;
            case 'edit_page':
                let edit_url_with_id = `${edit_url}/${id}`;
                dispatch({
                    type: TYPES.SET_PAGE,
                    payload: { page, status, edit_url: edit_url_with_id },
                });
                break;
            // case 'delete_modal':
            //     dispatch(getSingleReport(id, 'delete'));
            //     break;
            default:
                break;
        }
    };

//  fetch reports
export const getReports =
    (pageNumber, rows_per_page = null) =>
    async (dispatch, getState) => {
        dispatch(setLoading(true));
        let {
            report_search,
            pagination,
            sort_order_name,
            sort_order_direction,
        } = getState().report;
        let rows_per_page_val =
            rows_per_page !== null ? rows_per_page : getNumRows('report');

        // let searchPostParams = {
        //   search: report_search,
        //   activePage: pagination.activePage,
        //   page: pageNumber,
        //   rows_per_page: rows_per_page_val,
        //   sort_order_name: sort_order_name,
        //   sort_order_direction: sort_order_direction,
        // };

        //** MERN PAGINATE WITH OPTIMIZE SEARCH QUERY */
        let searchPostParams = {
            search: report_search,
            options: {
                page: pageNumber,
                limit: rows_per_page_val || 10,
                sort_by: sort_order_name,
                sort_order: sort_order_direction,
            },
        };

        ReportsService.paginateWithSearchReports(searchPostParams)
            .then((res) => {
                // let pagination = {
                //   totalCount: res.data.reports.total,
                //   activePage: res.data.reports.current_page,
                //   itemsCountPerPage: res.data.reports.per_page,
                //   totalItemsCount: res.data.reports.total,
                // };

                //** MERN PAGINATE WITH OPTIMIZE SEARCH QUERY */
                let pagination = {
                    totalCount: res.data.total_docs,
                    activePage: res.data.page,
                    itemsCountPerPage: res.data.limit,
                    totalItemsCount: res.data.total_docs,
                };

                dispatch({
                    type: TYPES.GET_REPORTS,
                    // payload: { reports: res.data.reports.docs, pagination: pagination },
                    payload: { reports: res.data.docs, pagination: pagination },
                });
                dispatch(setLoading(false));
            })
            .catch((err) => {
                dispatch(setLoading(false));
                // ToastDanger("Network error, please reload the page.");
                console.log(err);
            });
    };

export const handleSearchInputMUI = (e) => async (dispatch) => {
    dispatch({ type: TYPES.REPORT_SEARCH, payload: e.target.value });
};

// Sort by column name and direction
export const sortTableByColumn =
    (sort_order_name, sort_order_direction) => async (dispatch) => {
        let sortingParams = {
            sort_order_name: sort_order_name,
            sort_order_direction: sort_order_direction,
        };

        dispatch({ type: TYPES.SORT_BY_COLUMN, payload: sortingParams });
        dispatch(getReports());
    };

// returns selected rows only
export const getSelectedRows =
    (selectedRows, currentRows) => async (dispatch) => {
        // console.log(selectedRows, currentRows)
        let newArray = [];

        currentRows.map((current, i) => {
            selectedRows.map((selected, _i) => {
                if (selected.index == current.index) {
                    let selected = {
                        id: current.data[0],
                        name: current.data[1],
                    };
                    newArray.push(selected);
                }
            });
        });
        // console.log(newArray);
        dispatch({ type: TYPES.GET_ROWS_TO_DELETE, payload: newArray });
    };

// set the rows checked box
export const setRowChecked = () => async (dispatch) =>
    dispatch({ type: TYPES.SET_ROW_CHECKED });

// Set Modal
export const setModal = (modal, status) => async (dispatch) => {
    if (modal === 'generate_report') {
        dispatch({
            type: TYPES.SET_MODAL_GENERATE,
            payload: true,
        });
    }
    dispatch({
        type: TYPES.SET_MODAL,
        payload: { modal, status },
    });
};

//** CREATE REPORT */
export const createReport = (e, pageOrigin) => async (dispatch, getState) => {
    e.preventDefault();

    let { single_report } = getState().report;

    $('.btn-save').attr('disabled', 'disabled').html('Saving...');
    dispatch(setMUIPage(1));
    ReportsService.createReport(single_report)
        .then((res) => {
            if (pageOrigin == 'report') {
                // dispatch(blockRoute(false));
                dispatch(setPage('main_report_page'));
            }

            dispatch(clearReport());
            ToastSuccess(res.data.message);
            $('.btn-save').removeAttr('disabled').html('Save');
        })
        .catch((error) => {
            if (error.data?.errors.length > 0) {
                ToastDanger(error.data.errors);
            }
            $('.btn-save').removeAttr('disabled').html('Save');
            console.log(error);
        });
};

//** GENERATE REPORT */
export const generateReport = (e, id) => async (dispatch, getState) => {
    e.preventDefault();

    let { single_report } = getState().report;

    dispatch({ type: TYPES.GENERATE_BTN, payload: { id, status: true } });
    ReportsService.generateReport(id)
        .then((res) => {
            switch (res.data.status) {
                case 0:
                    ToastDanger(res.data.errors);
                    break;
                case 1:
                    // dispatch(setPage('main_report_page'));
                    ToastSuccess(res.data.message);
                    dispatch({
                        type: TYPES.GENERATE_BTN,
                        payload: { id, status: false },
                    });
                    dispatch({
                        type: TYPES.REPORT_JOB,
                        payload: {
                            jobId: res.data.jobId,
                            name: res.data.name,
                            // total_docs: res.data.total_docs,
                        },
                    });
                    break;
                default:
                    break;
            }
            $('.btn-save').removeAttr('disabled').html('Save');
        })
        .catch((error) => {
            if (error.data.errors.length > 0) {
                error.data.errors.map((err) => ToastDanger(err));
            } else {
                // ToastDanger("Network error, please reload the page.");
            }
            $('.btn-save').removeAttr('disabled').html('Save');
            console.log(error);
        });
};

//** REPORT CHECK JOB STATUS */
export const reportChecker = (jobId) => async (dispatch) => {
    try {
        const res = await ReportsService.reportChecker(jobId);
        // console.log('res', res);
        // if jobData found => status=1 => means doc is found => "completed"
        dispatch({
            type: TYPES.REPORT_STATUS_UPDATE,
            payload: {
                status: res.data.data.status, // 'completed'
                fileUrl: res.data.data.filePath, // ...
            },
        });
    } catch (err) {
        // If the API returns 0 => means doc is not found => "File is not ready"
        // => that implies still "in-progress" or "queued"
        // So you can do something like:
        dispatch({
            type: TYPES.REPORT_STATUS_UPDATE,
            payload: {
                status: 'in-progress',
                fileUrl: null,
            },
        });
    }
};

//** TEST REPORT */
export const testReport = (e) => async (dispatch, getState) => {
    e.preventDefault();

    let { single_report } = getState().report;

    ReportsService.testReport(single_report)
        .then((res) => {
            ToastSuccess(res.data.message);
            // dispatch({
            //     type: TYPES.TEST_REPORT_RESULT,
            //     payload,
            // });

            if (res.data.result.length > 0) {
                res.data.result.map((payload) =>
                    dispatch({
                        type: TYPES.TEST_REPORT_RESULT,
                        payload,
                    })
                );
            } else {
                dispatch({
                    type: TYPES.TEST_REPORT_RESULT,
                    payload: res.data.result,
                });
            }
            dispatch({
                type: TYPES.TEST_REPORT_RESULT,
                payload: res.data.result,
            });
        })
        .catch((error) => {
            if (error.data.errors.length > 0) {
                error.data.errors.map((payload) =>
                    dispatch({
                        type: TYPES.TEST_REPORT_RESULT,
                        payload,
                    })
                );
            } else {
                dispatch({
                    type: TYPES.TEST_REPORT_RESULT,
                    payload: error.data.errors,
                });
            }
            ToastDanger(error.data.message);
            console.log(error);
        });
};

//  fetch downloads
export const getDownloads =
    (pageNumber, rows_per_page = null) =>
    async (dispatch, getState) => {
        dispatch(setLoading(true));
        let {
            download_search,
            pagination,
            sort_order_name,
            sort_order_direction,
        } = getState().report;
        let rows_per_page_val =
            rows_per_page !== null ? rows_per_page : getNumRows('report');

        // let searchPostParams = {
        //   search: download_search,
        //   activePage: pagination.activePage,
        //   page: pageNumber,
        //   rows_per_page: rows_per_page_val,
        //   sort_order_name: sort_order_name,
        //   sort_order_direction: sort_order_direction,
        // };

        //** MERN PAGINATE WITH OPTIMIZE SEARCH QUERY */
        let searchPostParams = {
            search: download_search,
            options: {
                page: pageNumber,
                limit: rows_per_page_val || 10,
                sort_by: sort_order_name,
                sort_order: sort_order_direction,
            },
        };

        ReportsService.paginateWithSearchDownloads(searchPostParams)
            .then((res) => {
                // let pagination = {
                //   totalCount: res.data.downloads.total,
                //   activePage: res.data.downloads.current_page,
                //   itemsCountPerPage: res.data.downloads.per_page,
                //   totalItemsCount: res.data.downloads.total,
                // };

                //** MERN PAGINATE WITH OPTIMIZE SEARCH QUERY */
                let pagination = {
                    totalCount: res.data.total_docs,
                    activePage: res.data.page,
                    itemsCountPerPage: res.data.limit,
                    totalItemsCount: res.data.total_docs,
                };

                dispatch({
                    type: TYPES.GET_REPORT_DOWNLOADS,
                    // payload: { downloads: res.data.downloads.docs, pagination: pagination },
                    payload: {
                        downloads: res.data.docs,
                        pagination: pagination,
                    },
                });
                dispatch(setLoading(false));
            })
            .catch((err) => {
                dispatch(setLoading(false));
                // ToastDanger("Network error, please reload the page.");
                console.log(err);
            });
    };

// archive reports
export const moveToArchive = () => async (dispatch, getState) => {
    let { rows_to_delete } = getState().report;
    let id_arr = [];
    rows_to_delete.map((row) => {
        id_arr.push(row.id);
    });

    let params = {
        ids: JSON.stringify(id_arr),
    };

    ReportsService.ArchiveReport(params)
        .then((res) => {
            dispatch(setRowChecked());
            ToastSuccess(res.data.message);
            dispatch(getReports());
            dispatch(clearReport());
        })
        .catch((error) => {
            // ToastDanger("Network error, please reload the page.");
            console.log(error);
        });
};

// archive downloads
export const moveToArchiveDownloads = () => async (dispatch, getState) => {
    let { rows_to_delete } = getState().report;
    let id_arr = [];
    rows_to_delete.map((row) => {
        id_arr.push(row.id);
    });

    let params = {
        ids: JSON.stringify(id_arr),
    };

    ReportsService.ArchiveDownload(params)
        .then((res) => {
            dispatch(setRowChecked());
            ToastSuccess(res.data.message);
            dispatch(getDownloads());
            dispatch(clearReport());
        })
        .catch((error) => {
            // ToastDanger("Network error, please reload the page.");
            console.log(error);
        });
};

export const confirmDeleteDialogBox = () => async (dispatch, getState) => {
    let { rows_to_delete } = getState().report;
    let names = [];
    rows_to_delete.map((rows, i) => {
        names.push('<b>' + rows.name + '</b>');
    });

    SwalWarningHtml(
        'Warning!',
        `Do you want to remove the Report: ${names.join()}?`,
        () => dispatch(moveToArchive())
    );
};

export const confirmDeleteDialogBoxDownload =
    () => async (dispatch, getState) => {
        let { rows_to_delete } = getState().report;
        let names = [];
        rows_to_delete.map((rows, i) => {
            names.push('<b>' + rows.name + '</b>');
        });

        SwalWarningHtml(
            'Warning!',
            `Do you want to remove the Report Downloaded File: ${names.join()}?`,
            () => dispatch(moveToArchiveDownloads())
        );
    };
